/**
 * O que cobre a parte de baixo do palco (um painel, a folha de Pessoas) e como os
 * cartões se apresentam. Fica fora do React porque muda a cada quadro enquanto o
 * dedo arrasta uma folha: quem desenha o personagem lê daqui e ajusta o tamanho.
 */
const heights = new Map<string, number>();
const listeners = new Set<() => void>();
/** Quais cartões estão na tela agora (muda quando entra ou sai um). */
let signature = '';
let slimFor: string | null = null;
let expandedFor: string | null = null;

function emit(): void {
  listeners.forEach((listener) => listener());
}

/** Informa (ou retira, com `null`) a altura coberta por uma camada. */
export function setCover(id: string, px: number | null): void {
  const next = px === null ? undefined : Math.max(0, Math.round(px));
  if (heights.get(id) === next) return;
  if (next === undefined) heights.delete(id);
  else heights.set(id, next);
  const root = document.documentElement;
  const max = coverHeight();
  // O estilo dos cartões usa a mesma medida para ficar logo acima do que cobre.
  if (max > 0) root.style.setProperty('--stg-panel-h', `${max}px`);
  else root.style.removeProperty('--stg-panel-h');
  emit();
}

/** A altura que uma camada cobre agora (nada se ela não está na tela). */
export function coverOf(id: string): number | undefined {
  return heights.get(id);
}

export function coverHeight(): number {
  let max = 0;
  heights.forEach((value) => {
    if (value > max) max = value;
  });
  return max;
}

/** Algo mudou fora daqui (a conversa ao vivo abriu ou fechou): quem mede, mede de novo. */
export function notifyStageLayout(): void {
  emit();
}

export function onStageLayout(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Os cartões mudaram: a decisão de encolher vale só para o conjunto que a pediu. */
export function setCardsSignature(next: string): void {
  if (signature === next) return;
  signature = next;
  emit();
}

/** Sem espaço para o cartão inteiro e o rosto: o cartão vira uma linha. */
export function requestSlimCards(): void {
  if (slimFor === signature || expandedFor === signature) return;
  slimFor = signature;
  emit();
}

/** A pessoa tocou na linha para ver o cartão inteiro. */
export function expandCards(): void {
  if (expandedFor === signature) return;
  expandedFor = signature;
  emit();
}

export function slimCards(): boolean {
  return signature !== '' && slimFor === signature && expandedFor !== signature;
}

/** Só para os testes. */
export function resetStageCover(): void {
  heights.clear();
  signature = '';
  slimFor = null;
  expandedFor = null;
}
